import { Tooltip } from '@core/design-system/tooltip';

interface IProps {
  size?: number;
}

export const RetornoAdsTooltip = ({ ...props }: IProps) => (
  <>
    <Tooltip
      text="Este conteúdo é patrocinado. Lembre-se de que não constitui uma recomendação de investimentos."
      {...props}
    />
  </>
);
